/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
export async function getToken(tokenGeneratorURL: string): Promise<string> {
    const res = await fetch(tokenGeneratorURL, {
        method: 'POST'
    });
    const { token } = await res.json();
    return token;
}